import { AnaHazardId } from "@/store/services/facades/types";
import type { Icon } from "@phosphor-icons/react";
import {
  DropIcon,
  FireIcon,
  HurricaneIcon,
  ImageBrokenIcon,
  MountainsIcon,
  PersonSimpleSwimIcon,
  SnowflakeIcon,
  ThermometerHotIcon,
  TornadoIcon,
  WavesIcon,
  WindIcon,
} from "@phosphor-icons/react/dist/ssr";
import { anaHazards } from "../../lib/crg_apis/constants/hazards";

// Plucked from report glossary
type PhysicalRiskType = "Acute" | "Chronic" | "Both";

// Kept out of `types.ts` so `tailwind.report.config.js` can read the colours without the rest of branding.
export const hazardMeta = {
  coastal_inundation: { icon: WavesIcon, color: "#2563EB", physicalRiskType: "Both" },
  cyclone_wind: { icon: TornadoIcon, color: "#F97316", physicalRiskType: "Acute" },
  cyclone_storm_surge: { icon: HurricaneIcon, color: "#10B981", physicalRiskType: "Acute" },
  flood_riverine: { icon: DropIcon, color: "#0EA5E9", physicalRiskType: "Acute" },
  flood_surfacewater: { icon: PersonSimpleSwimIcon, color: "#8B5CF6", physicalRiskType: "Acute" },
  forest_fire: { icon: FireIcon, color: "#E11D48", physicalRiskType: "Acute" },
  freeze_thaw: { icon: SnowflakeIcon, color: "#06B6D4", physicalRiskType: "Chronic" },
  heat: { icon: ThermometerHotIcon, color: "#EC4899", physicalRiskType: "Both" },
  landslide: { icon: MountainsIcon, color: "#84CC16", physicalRiskType: "Acute" },
  soil_movement: { icon: ImageBrokenIcon, color: "#F59E0B", physicalRiskType: "Chronic" },
  wind: { icon: WindIcon, color: "#01224c", physicalRiskType: "Acute" },
} satisfies Record<AnaHazardId, { icon: Icon; color: string; physicalRiskType: PhysicalRiskType }>;

export const getHazardName = (hazardId: AnaHazardId | "total"): string => {
  return hazardId === "total" ? "All Hazards" : (anaHazards[hazardId]?.name ?? hazardId);
};
